
<template>
  <div class="w-full" v-if="isCardActiveLocal">
    <div class="flex mb-2" style="justify-content: space-between;">
      <div class="flex" style="align-items: center;">
        <h4 style="margin-bottom: 0;">Select a Subject</h4>
      </div>
      <vx-input-group class="input-group-with-input-for-filtering ml-4" style="">
        <template slot="prepend">
          <div class="prepend-text ">
            <span><feather-icon class="pt-1" icon="SearchIcon" svg-classes="stroke-current h-5 w-5"></feather-icon></span>
          </div>
        </template>

        <vs-input class="dashboard-filter-input" placeholder="Search here..." v-model="gradeSubjectFilterText"/>
      </vx-input-group>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
        <div v-if="!loadingDataCards" class="vx-row data-card-container">
          <div class="vx-col mb-3" v-for="(subject, index) in gradeSubjects" :key="index" style="padding-left: 0; padding-right: 0;">
            <data-card :smallText="true" class="mx-2" type="gradeSubject" @handleClick="selectedGradeSubject(subject)" :title="subject.subject" :myTime="subject.timeSpentMaxStudent" :avgTime="subject.timeSpentAvgClassroom" :radialData="[subject.scoreMaxStudent, subject.scoreAvgClassroom]" :highestAvg="true"/>
          </div>          
        </div>
        <div v-if="loadingDataCards" class="vx-row data-card-container">
          <div class="vx-col w-full mb-3" style="padding-left: 0; padding-right: 0;">
            <data-card-skeleton :count="4"/>
          </div>
        </div>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full">
        <line-chart :isLoading="loadingChartsTime" @filterDropdownChanged="filterDropdownChangedStudentGraphTimeSpent" :series="timeSpentSeries" :title="'Time Spent'" :filterList="listOfgradeSubjectsForDropdown"/>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <line-chart :isLoading="loadingChartsScore"  @filterDropdownChanged="filterDropdownChangedStudentGraphScore" :series="scoreSeries" :title="'Score'" :filterList="listOfgradeSubjectsForDropdown"/>
      </div>
    </div>
  </div>
</template>


<script>
import vSelect from 'vue-select'
import DataCard from './DataCard.vue'
import UserDetails from './UserDetails.vue'
import CustomSkeleton from './CustomSkeleton.vue'
import DataCardSkeleton from './DataCardSkeleton.vue'
import LineChart from './LineChart.vue';
export default {
  name: "gradeSubject",
  components: {
    vSelect,
    DataCard,
    UserDetails,
    CustomSkeleton,
    DataCardSkeleton,
    LineChart
  },
  props: {
    isCardActive: {
      type: Boolean,
      required: true
    },
    userDetails:{
      type:Object,
      required: true
    }
  },
  data() {
    return {
      loadingDetails:true,
      loadingDataCards:true,
      loadingChartsTime:true,
      loadingChartsScore:true,
      gradeSubjects: [],
      originalgradeSubjects: [],
      gradeSubjectFilterText: "",
      listOfgradeSubjectsForDropdown: [],
      scoreSeries:[],
      timeSpentSeries:[],
      userDetailsObject:{},
    };
  },
  watch: {
    isCardActive: function(val) {
      var self = this;
      if(val){
        self.getgradeSubjects();
        localStorage.setItem("Teacher_Position",JSON.stringify(self.userDetails));
        localStorage.setItem("Active_Card","1");
      }
      if(!val){
        self.timeSpentSeries = [];
        self.scoreSeries = [];
      }
    },
    gradeSubjectFilterText: function(val) {
      var self = this;
      if(val) {
        self.gradeSubjects = self.originalgradeSubjects.filter(function(x) { return x.name.toLowerCase().includes(val.toLowerCase()) });
      } else {
        self.gradeSubjects = self.originalgradeSubjects;
      }
    }
  },
  computed: {
    isCardActiveLocal: {
      get() {
        return this.isCardActive;
      },
      set(val) { }
    },
  },
  methods: {
    getgradeSubjects() {
      var self = this;

      self.loadingDetails = true;
      self.loadingDataCards = true;

      var onSuccess = function(response) {
        self.gradeSubjects = response.data;
        self.listOfgradeSubjectsForDropdown = self.gradeSubjects.map((item) => {return { label: item.subject, value: item.subjectId }});

        self.originalgradeSubjects = self.gradeSubjects;
      };

      var onFinally = function() {
        self.loadingDataCards = false;
        self.loadingChartsTime = false;
        self.loadingChartsScore = false;
      };
      self.$ajaxGet(self, `PrincipalDashboard/GetSubjectList?selectedGradeId=${self.userDetails.selectedGrade.gradeId}`, onSuccess, onFinally);
    },
    selectedGradeSubject(gradeSubject){
      this.$emit('selectedGradeSubject', gradeSubject);
      this.userDetails.selectedGradeSubject = gradeSubject;
    },
    filterDropdownChangedStudentGraphTimeSpent(gradeSubjectName,gradeSubjectId,selectedDate) {
      var self = this;
      this.loadingChartsTime = true;
      var onSuccess = response =>{
        self.timeSpentSeries = [
          {
            name: "Single Student Avg.",
            data: response.data.avaragesList,
          },
          {
            name: "Combined Student Avg.",
            data: response.data.timeSpentAvaragesList
          }
        ];
      }
      var onFinally = response =>{
        self.loadingChartsTime = false;
      }
        self.$ajaxGet(self, `PrincipalDashboard/TimeSpentGraphHighest?month=${selectedDate.monthIndex}&year=${selectedDate.year}&gradeId=${this.userDetails.selectedGrade.gradeId}&courseId=${gradeSubjectId}` , onSuccess, onFinally);
    },
    filterDropdownChangedStudentGraphScore(gradeSubjectName,gradeSubjectId,selectedDate) {
      var self = this;
      this.loadingChartsScore = true;
      var onSuccess = response =>{
        self.scoreSeries = [
          {
            name: "Single Student Avg.",
            data: response.data.scoreList,
          },
          {
            name: "Combined Student Avg.",
            data: response.data.scoreListAvg,
          },
        ];
      }
    
      var onFinally = response =>{
        self.loadingChartsScore = false;
      }
      self.$ajaxGet(self, `PrincipalDashboard/HigestScore?month=${selectedDate.monthIndex}&year=${selectedDate.year}&gradeId=${this.userDetails.selectedGrade.gradeId}&courseId=${gradeSubjectId}` , onSuccess, onFinally);
    },
  },
  created() {
  },
  mounted() {
  }
};
</script>